import preferencesReducers from './preferences-slice';

export default {
  ...preferencesReducers,
};

export * from './preferences-slice';
